import { useEffect, useState } from "react";

/**
 * Returns true when the given media query matches. Subscribes to changes via
 * MediaQueryList. Initial render returns false (matches Vite SSR-friendly
 * pattern even though apps/app is fully client-side).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}
